import React, { Component } from 'react'
import axios from 'axios'
import Select from 'react-select'
import CheckboxTree from 'react-checkbox-tree';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// import appSettings from '../assets/app-settings.json';

export class RequestShapefiles extends Component {

    state = {
        geodatasets: [],
        data: [],
        sites: [],
        selectedSite: null,
        groupedLayers: [],
        checked: [],
        expanded: [],
        selectedDatasets: {}
    }

    componentDidMount() {
        this.restoreSelectedSite();
        this.fetchGeodatasets();
    }

    restoreSelectedSite = (isForceUpdate) => {
        const siteString = localStorage.getItem("geoSelectedSite");
        if (siteString) {
            const site = JSON.parse(siteString);
            this.setState({
                selectedSite: site
            }, () => {
                this.handleSiteSelect(site);
            });
        }
    }

    restoreSelectedDatasets = () => {
        const datasetsString = localStorage.getItem("geoDatasetsSelected");
        if (datasetsString) {
            const datasets = JSON.parse(datasetsString);

            let checked = [];
            if (this.state.selectedSite) {
                checked = datasets[this.state.selectedSite.name];
            }

            this.setState({
                checked: checked,
                selectedDatasets: datasets
            });
        }
    }

    fetchSites = (siteNames) => {
        const appSettings = window.AppConfigSettings;
        const url = appSettings.baseApiUrl + "/sites?fields=id,url,name,description";
        axios.get(url)
            .then(res => {
                const siteData = res.data;
                const sites = siteData.map(site => {
                    return { id: site.id, name: site.name, description: site.description, value: site.name, label: site.description };
                }).filter(s => siteNames.includes(s.name) && !appSettings.ExcludedSites.includes(s.name));
                this.setState({
                    sites: sites
                }, () => {
                    this.restoreSelectedSite(true);
                    localStorage.setItem("allSites", JSON.stringify(sites));
                });
            });
    }

    fetchGeodatasets() {
        this.setIsBusyStatus(true);
        const appSettings = window.AppConfigSettings;
        const url = appSettings.baseApiUrl + "/downloads/geodatasets?flat=true";
        axios.get(url)
            .then(res => {
                const geodatasets = res.data;

                // const maxId = Math.max(...geodatasets.map(g => g.id));
                // console.log("[max]", maxId);
                const siteNames = [...new Set(geodatasets.map(g => g.siteName))];
                // console.log("[siteNames]", siteNames);
                this.fetchSites(siteNames);

                // const groupByKey = (list, key) => list.reduce((hash, obj) => ({...hash, [obj[key]]:( hash[obj[key]] || [] ).concat(obj)}), {});
                // const groupedData = groupByKey(geodatasets, 'siteName');
                // console.log(groupedData);            
                this.setState({
                    geodatasets: geodatasets
                }, () => {
                    this.restoreSelectedDatasets();
                    localStorage.setItem("geoDatasets", JSON.stringify(geodatasets));
                });
            })
            .finally(()=>{
                this.setIsBusyStatus(false);
            });
    }

    handleSiteSelect = (site) => {
        console.log("[site]", site);
        let checkedItems = [];
        if (site) {
            checkedItems = this.state.selectedDatasets[site.name];
        }
        this.setState({
            selectedSite: site,
            checked: checkedItems
        });
        localStorage.setItem("geoSelectedSite", JSON.stringify(site));

        let maxId = Math.max(...this.state.geodatasets.map(g => g.id)) + 1;

        const data = this.state.geodatasets
            .filter(g => g.siteName === site.name)
            .map(g => {
                const item = { ...g };
                item.value = g.id;
                item.label = g.layerName;
                return item;
            });

        const groupNames = [...new Set(data.map(g => g.groupName))];
        const groupedLayers = groupNames.map((name) => {
            let groupLayer = {
                value: maxId++,
                label: name,
                children: data.filter(d => d.groupName === name)
            }
            return groupLayer;
        });

        this.setState({
            data: data,
            groupedLayers: groupedLayers
        });

        // console.log(groupedLayers);        
    }

    groupByKey = (items, key) => {
        return items.reduce((hash, obj) => ({ ...hash, [obj[key]]: (hash[obj[key]] || []).concat(obj) }), {});
    };

    onCheck = (checked) => {
        const selectedDatasets = { ...this.state.selectedDatasets };
        if (this.state.selectedSite) {
            selectedDatasets[this.state.selectedSite.name] = checked;
        }
        this.setState({
            checked: checked,
            selectedDatasets: selectedDatasets
        });
        console.log("[checked]", checked);
        console.log("[selectedDatasets]", selectedDatasets);

        localStorage.setItem("geoDatasetsSelected", JSON.stringify(selectedDatasets));
    }

    onExpand = (expanded) => {
        this.setState({ expanded: expanded });
    }
    
    setIsBusyStatus = (isBusy) => {
        if (this.props.isBusyChange) {
            this.props.isBusyChange(isBusy);
        }
    }

    render() {
        return (
            <div>
                <Select
                    className="sites-select"
                    options={this.state.sites}
                    onChange={this.handleSiteSelect}
                    value={this.state.selectedSite}
                    placeholder="Select beach site..."
                    theme={(theme) => ({
                        ...theme,
                        borderRadius: 3,
                        colors: {
                          ...theme.colors,
                          primary: '#3396c7',
                          primary25: '#3396c728',
                        },
                      })}
                />
                <div className="treeview-container">
                    <CheckboxTree
                        checked={this.state.checked}
                        expanded={this.state.expanded}
                        iconsClass="fa5"
                        nodes={this.state.groupedLayers}
                        onCheck={this.onCheck}
                        onExpand={this.onExpand}
                        icons={{
                            check: <FontAwesomeIcon className="rct-icon rct-icon-check" icon="check-square" />,
                            // uncheck: <FontAwesomeIcon className="rct-icon rct-icon-uncheck" icon={['fas', 'square']} />,
                            // halfCheck: <FontAwesomeIcon className="rct-icon rct-icon-half-check" icon="check-square" />,
                            // expandClose: <FontAwesomeIcon className="rct-icon rct-icon-expand-close" icon="chevron-right" />,
                            // expandOpen: <FontAwesomeIcon className="rct-icon rct-icon-expand-open" icon="chevron-down" />,
                            // expandAll: <FontAwesomeIcon className="rct-icon rct-icon-expand-all" icon="plus-square" />,
                            // collapseAll: <FontAwesomeIcon className="rct-icon rct-icon-collapse-all" icon="minus-square" />,
                            // parentClose: <FontAwesomeIcon className="rct-icon rct-icon-parent-close" icon="folder" />,
                            // parentOpen: <FontAwesomeIcon className="rct-icon rct-icon-parent-open" icon="folder-open" />,
                            // leaf: <FontAwesomeIcon className="rct-icon rct-icon-leaf-close" icon="file" />
                        }}
                    />
                </div>
            </div>
        )
    }
}

export default RequestShapefiles
